import React from 'react';
import { Helmet } from "react-helmet";
import '../../styles/forwarding.css'; // Import Forwarding specific CSS
import '../../styles/Fonts.css'; // Import Font specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import bgImage from '../../assets/new/forwarding2.webp';
import ForwardingServices from './ForwardingServices';
import ForwardingBenefits from './ForwardingBenefits';
import ForwardingFAQ from './ForwardingFAQ';

const HeroForwarding = () => {
  return (
    <>
      <Helmet>
        <title>Forwarding Services | RCS Logistics Philippines</title>
        <meta name="description" content="Professional forwarding services by RCS Logistics Philippines. Domestic and international freight forwarding with expert handling and comprehensive coverage." />
        <meta name="keywords" content="forwarding services, logistics forwarding, freight forwarding, domestic forwarding, international forwarding, RCS Logistics Philippines, professional forwarding, cargo forwarding, shipping forwarding" />
        <meta property="og:url" content="https://rcslogisticsph.com/forwarding" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Forwarding Services | RCS Logistics Philippines" />
        <meta property="og:description" content="Professional forwarding services with domestic and international coverage by RCS Logistics Philippines." />
        <meta property="og:image" content="https://rcslogisticsph.com/forwarding-hero-image.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Forwarding Services | RCS Logistics Philippines" />
        <meta property="twitter:description" content="Professional forwarding services with domestic and international coverage by RCS Logistics Philippines." />
        <meta property="twitter:image" content="https://rcslogisticsph.com/forwarding-hero-image.png" />
      </Helmet>

      {/* Hero Section */}
      <section 
        className="forwarding-hero-section" 
        style={{ 
          backgroundImage: `url(${bgImage})`
        }}
      >
        <div className="forwarding-hero-overlay"></div>
        <div className="container hero-content">
          <div className="row">
            <div className="col-lg-10 col-xl-9">
              <div className="text-start">
                <button className="hero-badge" disabled>
                  PROFESSIONAL FORWARDING SERVICES
                </button>
                <h1 className="hero-main-title text-white">
                  Comprehensive Forwarding Solutions
                </h1>
                <p className="hero-description text-white">
                  Expert domestic and international forwarding services with seamless coordination and reliable delivery.
                </p>
                <div className="hero-actions">
                  <a href="/contactUs" className="btn-primary-hero">Get a Quote</a>
                  <a href="#forwarding-services" className="btn-secondary-hero">Our Services</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Include the other sections */}
      <ForwardingServices />
      <ForwardingBenefits />
      <ForwardingFAQ />
    </>
  );
};

export default HeroForwarding;
